import type { ClickoutUrl } from '@/helpers/clickout-helper';

import { useLanguageStore } from '@/helpers/composables/useStores';
import { useUserAgent } from '@/helpers/composables/useUserAgent';

export function setTubiAffiliationTags(clickoutUrl: ClickoutUrl, providerId: number) {
	const { country } = useLanguageStore();
	const { deviceOs } = useUserAgent();

	if (providerId !== 73 || country.value !== 'GB') return;

	if (deviceOs.value === 'ios') clickoutUrl.set('uct_ua', 'ios');
	if (deviceOs.value === 'android') clickoutUrl.set('uct_ua', 'and');
}
